export default "__VITE_ASSET__34fc16d3__"